module.exports = __webpack_public_path__ + "static/ASKMED-0982a2a1ddfdfd96bbefafafc92250c1.png";